import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";

export default function ChipArrayRed(props) {
  const classes = useStyles();
  let { chipData, handleDelete, key2 } = props; 
  // const [chipData, setChipData] = React.useState([
  //   { key: 0, label: 'Банковская книга' },
  //   { key: 1, label: 'Кредитование' },
  //   { key: 2, label: 'Инвестиции' },
  // ]);


  return (
    <Grid container spacing={1} className={classes.root}>
      {chipData && chipData.length > 0 && chipData.map((data, ind) => {
        return (
          <Grid item key={key2+ind} className={classes.chipCntr}>
            <Chip
              label={
                <Typography className={classes.chipLabel}>
                  {data[key2]}
                </Typography>
              }
              size="small"
              deleteIcon={
                <CloseIcon className={classes.deleteIcon} />
              }
              onDelete={()=>handleDelete(data)}
              className={classes.chip}
            />
          </Grid>
        );
      })}
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 0,
    marginTop: -1,
  },

  chip: {
    backgroundColor: '#EB505E',
    height: 'auto',
    minHeight: 24,
    '&:focus': {
      backgroundColor: '#EB505E',
    }
  },

  chipCntr: {
    paddingBottom: '6px !important'
  },

  chipLabel: {
    color: '#FFFFFF',
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '13px',
    lineHeight: '16px',
    paddingRight: 2,
    whiteSpace: 'break-spaces'
  },

  deleteIcon: {
    color: '#FFFFFF',
    marginRight: 8
  }
}));